import { useEffect, useState } from "react";
import Lenis from "lenis";
import { motion, useMotionValue, useSpring } from "framer-motion";
import { VelocityBlob } from "./VelocityBlob";

export const LiquidFX = () => {
  const [active, setActive] = useState(false);
  const x = useMotionValue(-200);
  const y = useMotionValue(-200);
  const sx = useSpring(x, { stiffness: 140, damping: 18, mass: 0.5 });
  const sy = useSpring(y, { stiffness: 140, damping: 18, mass: 0.5 });

  useEffect(() => {
    document.documentElement.classList.add("lenis-active");
    const lenis = new Lenis({ duration: 1.4, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onMove = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
      setActive(!!e.target.closest?.("[data-aura]"));
    };
    window.addEventListener("mousemove", onMove, { passive: true });

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.removeEventListener("mousemove", onMove);
      document.documentElement.classList.remove("lenis-active");
    };
  }, [x, y]);

  return (
    <>
      <VelocityBlob />
      <div className="noise-overlay" aria-hidden="true" />
      <motion.div
        style={{ x: sx, y: sy }}
        className="pointer-events-none fixed left-0 top-0 z-[70] hidden lg:block"
        aria-hidden="true"
        data-testid="cursor-aura"
      >
        <div
          className={`-translate-x-1/2 -translate-y-1/2 rounded-full transition-[width,height,opacity] duration-500 ease-liquid ${
            active ? "h-40 w-40 opacity-90" : "h-24 w-24 opacity-60"
          }`}
          style={{
            background:
              "radial-gradient(circle, rgba(212,175,55,0.4) 0%, rgba(212,175,55,0.14) 45%, rgba(212,175,55,0) 70%)",
            mixBlendMode: "multiply",
          }}
        />
      </motion.div>
    </>
  );
};
